<div class="user-profile-cont">
  <div class="profile-section">
    <ddc-profile-pic-only
      [dynamicRoute]="_dynamicRoute"
      [isProfilePicLoading]="_isProfilePicLoading"
      [userProfilePic]="_userProfilePic"
    >
    </ddc-profile-pic-only>
    <div class="user-info">
      <div class="username-container">
        <div
          class="username"
          routerLinkActive="router-link-active"
          [ngClass]="{
            'ddc-font-color-dark': _isLightTheme || _isPaperTheme,
            'ddc-font-color-light': _isDarkTheme,
          }"
          [routerLink]="'/users/' + _username"
        >
          {{ _username }}
        </div>
        @if (_verified === true) {
          <mat-icon class="ml-1 small-icon ddc-plus-icon" matTooltip="Verified">verified</mat-icon>
        }
        @if (_subscription === 'Plus') {
          <mat-icon class="ml-1 small-icon ddc-plus-icon" matTooltip="Plus">bolt</mat-icon>
        }
        @if (_subscription === 'Pro') {
          <mat-icon class="ml-1 small-icon ddc-plus-icon" matTooltip="Pro">diamond</mat-icon>
        }
        @if (simple === true) {
          <div class="simple-user-info-languages">
            @if (language_1 !== undefined) {
              <div class="privacy-dot mr-1" *ngIf="simple !== true">•</div>
              <div class="ddc-content-lng mr-1">
                <ddc-country-flag [ddc_lng]="language_1"></ddc-country-flag>
              </div>
            }
            @if (language_2 !== undefined) {
              <div class="ddc-content-lng">
                <ddc-country-flag [ddc_lng]="language_2"></ddc-country-flag>
              </div>
            }
          </div>
        }
      </div>
      <div class="followers">{{ followerCount }} followers</div>
      <div class="bottom-row" *ngIf="minimal !== true">
        <div class="post-time" *ngIf="simple !== true">{{ creationTime }}</div>
        <!-- <div class="privacy-dot" *ngIf="simple !== true">•</div> -->
        <div class="privacy-icon" *ngIf="simple !== true">
          <mat-icon [matTooltip]="privacyTooltip">{{ privacyIcon }}</mat-icon>
        </div>
        @if (simple !== true) {
          @if (language_1 !== undefined) {
            <div class="privacy-dot mr-1">•</div>
            <div class="ddc-content-lng mr-1">
              <ddc-country-flag [ddc_lng]="language_1"></ddc-country-flag>
            </div>
          }
          @if (language_2 !== undefined) {
            <div class="ddc-content-lng">
              <ddc-country-flag [ddc_lng]="language_2"></ddc-country-flag>
            </div>
          }
        }
        @if (language_1 === undefined && language_2 === undefined && contentTypeIcon) {
          <div class="privacy-icon">
            <mat-icon [matTooltip]="contentTypeTooltip">{{ contentTypeIcon }}</mat-icon>
          </div>
        }
        @if (_dictionaries.length !== 0 || _category !== undefined) {
          <div class="privacy-dot"></div>
        }
        @if (_dictionaries.length !== 0) {
          <div class="ddc-content-dic-elements" *ngIf="_dictionaries !== undefined">
            <ddc-dic-s *ngFor="let dic of _dictionaries | slice: 0 : 3" [label]="dic.title"></ddc-dic-s>
          </div>
        }
        @if (_category !== undefined && _category?.length > 0) {
          <ddc-card-category [category]="_category"></ddc-card-category>
        }
      </div>
      <div class="bottom-row"></div>
    </div>
  </div>
</div>
